<template>
  <div>
        <search v-if="searchDisable !== true" v-model="search" />

          <div class="filters">
            <div v-for="dFilter in dateFilter" :key="dFilter.key">
                  <label>{{dFilter.title}} <span v-show="params[dFilter.key]" @click="params[dFilter.key]=null" class="link">сбросить</span></label>
                 <datetime  v-model="params[dFilter.key]"  @input="params['page'] = 1"  class="from-control"  type="date" format="dd/MM/yyyy"></datetime> 
            </div>

  
            <div  v-for="f in staticFilters" :key="f.key">
              <label>{{ f.title }}</label>
              <select  @change="params['page'] = 1" 
                  v-model="params[f.key]" 
                  class="form-control">
                <option  :value="v.id" v-for="(v,vK) in f.items" :key="vK">{{v.title}}</option>
              </select>
            </div>
   
            <div  v-for="filter in filters" :key="filter.key" >
              <filter-item
                  :modal="filter.key"
                  :title="filter.title"
                  :single="filter.single"
                  :params="filter['params']"
                  :titleKey="filter.titleKey"
                  v-model="params[`${filter.field_key ? filter.field_key : filter.key}_id`]"
                  @input="params['page'] = 1"
              />
            </div>
            <div v-if="withMap">
              <label>Вид контента</label>
              <select v-model="type" class="form-control">
            <option :value="`list`">Список</option>
            <option :value="`map`">Карта</option>
        </select>
            </div>
                  
            
      
        </div>


    <div :class="`position-relative overflow-hidden ${loading ? 'loading' : ''}`">
      <div v-if="(value.length && !simple) || isAdd || is_filter || isUpdate || setImport===true || (functions && functions.length && value.length)" class="row mb-2">
        <div class="col-12 col-md-6">
          <ul class="status">
            <li v-if="isAdd && type==='list'">
              <button
                class="btn btn-info btn-sm btn-icon"
                @click="addItem"
              >
                <span class="ti-plus"></span>
                Добавить
              </button>
            </li>
            <li v-if="is_filter">
              <button class="btn btn-sm btn-icon">
                <span class="ti-filter"></span>
                Фильтровать
              </button>
            </li>
            <li v-if="isUpdate && type==='list'">
              <button class="btn btn-sm btn-warning " @click="getList">
                <span class="ti-reload"></span>
                
              </button>
            </li>
            <li v-if="exportsData">
              <span v-for="(item, key) in exportsData" :key="key">
                <blob-download :params="params" :url="item.url" :name="item.name" v-if="item.type == 'export-coords'">
                  Выгрузить координаты
                </blob-download>
              </span>
            </li>
            <li v-if="functions && functions.length && value.length">
              <select
                v-model="funcSelected"
                @change="changeFunction"
                class="btn btn-sm btn-select"
                name=""
                id=""
              >
                <option value="0">Действие</option>
                <option
                  v-for="func in functions"
                  :key="func.id"
                  :value="func.id"
                >
                  {{ func.title }}
                </option>
              </select>
            </li>
            <li v-if="value.length && !simple">
              <button class="btn btn-sm btn-warning btn-icon" @click="val = []">
                <span class="ti-close"></span>
                Сброить {{ value.length }}
              </button>
            </li>
          </ul>
        </div>
        <div class="col-12 col-md-6">
          <div v-if="exportsData">
            <span v-for="(item, key) in exportsData" :key="key">
              <span v-if="item.type == 'export-all'" class="flex ai-center md-min:jc-end ">
                <blob-download :params="params" :url="item.url" :name="item.name" class="m-y-2">Выгрузить</blob-download>
                <excel-upload v-if="item.url_import" :url="item.url_import" :name="item.name" class="sm-min:m-l-3 m-y-2" />
              </span>
            </span>
          </div>
        </div>
      </div>
      <ul v-if="!simple" class="selected-items">
        <li v-for="v in value" :key="v.id">
          <span>{{ v[checkSelect] }}</span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>
      <div class="mb-4 text-right">
        <div v-if="items.last_page" class="modal-title badge badge-danger">
          {{
            items.last_page ? "Всего: " + items.total + " шт." : "Загрузка..."
          }}
        </div>
      </div>
      <div class="row" v-if="columns && columns.length && items">
        <div class="col-12">
            <keep-alive v-if="type==='map'">
                  <list-map :cardLink="cardLink" :params="params"></list-map>
            </keep-alive>

            <keep-alive v-else>
              <div class="table-full-width table-responsive">
                  <paper-table
                    v-show="items.data.length"
                    type="hover"
                    :simple="simple"
                    :card="cardLink"
                    :cardLink="cardLink"
                    :data="items.data"
                    :columns="columns"
                    :removeItem="removeItem"
                    v-model="val"
                    :dataObject="dataObject"
                    :current_page="items.current_page"
                      @sortby="sortby"
                  ></paper-table>
                    <h4 v-if="items.data.length === 0">Элементов не найдено</h4>
              </div>
            </keep-alive>
        </div>
      </div>

      <div v-if="!type || type==='list'" class="fixed-pagination">
        <div class="responsive-pagination">
          <paginate
            v-if="items.last_page"
            v-show="items.last_page > 1"
            :container-class="'pagination-project'"
            :page-range="3"
            v-model="items.current_page"
            :pageCount="items.last_page"
            :prevText="'Назад'"
            :nextText="'Далее'"
          ></paginate>
        </div>
      </div>
    </div>



    <add-item
      :openItem="openItem"
      @close="add=false"
      v-if="isAdd && fields && fields.length && setLink && add===true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
  </div>
</template>
<script>
import PaperTable from "./PaperTable";
import Search from "./Search";
  import ListMap from '@/components/ListMap';
import { mapState } from "vuex";
export default {
  name: "List",
  data() {
    return {
      type:'list',
      add:false,
        sort:{
          orderBy:'id',
          orderType:'DESC',
      },
      dataObject: {},
      funcSelected: 0,
      loading: true,
      loadingSearch: false,
      searcher: null,
      search: "",
      items: {
        last_page: 0,
        current_page: 1,
        total: 0,
        data: [],
      },
    };
  },
  components: {
    PaperTable,
     ListMap,
    Search,
    "add-item": () => import("./Modals/AddItem"),
  },

  props: {
    openItem: {
      default: true,
    },
    value: {
      default: function () {
        return [];
      },
    },
    searchDisable: {},
    setLink: {},
    itemLink: {},
    title: {},
    simple: {
      default: false,
    },
    withMap: {
      default: false,
    },
    setImport: {
      default: false,
    },
    columns: {},
    removeLink: {},
    cardLink: {},
    modalCreate: {},
    disable_add: {},
    is_filter: {},
    isAdd: {},
    isUpdate: {},
    functions: {},
    fields: {},
    exportsData: null,
    params: {
      default: function () {
        return {};
      },
    },
      filters: {
      default: function () {
        return [];
      },
    },
    staticFilters: {
      default: function () {
        return [];
      },
    },
    dateFilter: {
      default: function () {
        return [];
      },
    },
  },
  computed: {
    checkSelect() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].checkbox === true) {
          return this.columns[i].key;
        }
      }
      return null;
    },
    ...mapState(["newOrder", "lastUpdate"]),
    page() {
      return this.items.current_page;
    },
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    newOrder(val) {
      if (val && this.cardLink === "orders") {
        this.getList(false);
      }
    },
    page(val) {
      if (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.getList();
        }, 100);
      }
    },
    search() {
      this.items.current_page = 1;
      this.loadingSearch = true;
      this.loading = true;
      clearTimeout(this.searcher);
      this.searcher = setTimeout(() => {
        this.getList(false);
      }, 1000);
    },
    lastUpdate(val) {
      if (val) {
        console.log('LAST UPDATE');
        this.getList();
      }
    },
    params: {
      handler: function (val) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        this.items.current_page = val.page;
        setTimeout(() => {
          this.getList();
        }, 100);
      },
      deep: true,
    },
  },
  methods: {
    clearFilter(){
        this.$emit('clearFilter' , true);
    },
     sortby(val){
        this.sort = val;
        this.getList();
    },
    addItem(){

        this.add=true;
    },
    changeFunction(val) {
      this.$emit("changeFunction", this.funcSelected);
      this.funcSelected = 0;
    },
    removeItem(itemID) {
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.itemLink}/${itemID}`, { _method: 'DELETE' })
            .then((response) => {
              this.$emit('deleted',true);
              this.getList();
            })
            .catch((error) => {})
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    getList(loading = true, resetPage = false) {
      let params = this.params ? this.params : {};
      params["page"] = this.items.current_page;
      params["search"] = this.search;
      params["order"] = `${this.sort.orderType === 'DESC' ? '' : '-'}${this.sort.orderBy}`;
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      if (resetPage ===true){
        params['page'] = 1;
      }
      this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          
         if (response.data) {
            this.items.data = response.data.data;
            this.items.total = response.data.meta.total;
            const perPage = response.data.meta.per_page;
            this.items.last_page = Math.ceil(this.items.total / perPage);
            if (response.data.data) {
              let data = response.data.data;
              for (let i = 0; i < this.value.length; i++) {
                this.dataObject[this.value[i].id] = this.value[i];
              }
              for (let i = 0; i < data.length; i++) {
                this.dataObject[data[i].id] = data[i];
              }
              if(this.itemLink == 'statuses' && this.value.length){
                for(var i in this.dataObject){
                  if(this.value[0].code != 'accept' && this.dataObject[i].code == 'accept')
                    this.dataObject[i].passed = true
                }
              }
            }
          }
          if (response.data.type) {
            this.$emit("type", response.data.type);
          }
        })
        .catch(() => {
          this.items.last_page = 1;
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },

    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="scss">
ul.selected-items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  overflow-x: scroll;
  max-width: 100%;
  @media (min-width: 769px) {
    flex-wrap: wrap;
  }

  & > li {
    max-width: 180px;
    border-radius: 5px;
    margin-right: 10px;
    background: #222;
    color: #fff;
    font-size: 10px;
    margin-bottom: 10px;
    padding: 4px 6px;
    display: flex;
    & > span {
      display: block;
      &:last-child {
        font-size: 8px;
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
